import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormHelperText,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
  Zoom,
  Dialog,
  Avatar,
  Divider,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/CheckCircleOutline";
import ClearIcon from "@material-ui/icons/HighlightOff";
import Notify from "src/notification/Notify";
import * as Yup from "yup";
import { Formik } from "formik";
import { UsersData, UsersHeader } from "src/ContextAPI";
import { isMobile } from "react-device-detect";
import { CameraAlt, Send } from "@material-ui/icons";
import Cropper from "react-cropper";
import axios from "axios";

const VanNewPatient = ({ accreditedCompany, getDoctorsPatient }) => {
  const { users } = React.useContext(UsersData);
  const { sidebarHeader } = React.useContext(UsersHeader);
  const cropperRef = useRef();
  var profileimage = useRef();
  const [imgUploadTemp, setImgUploadTemp] = useState(null);
  const [image, setImage] = useState(null);
  const [openCropImage, setOpenCropImage] = useState(false);
  // const [selectedGender, setSelectedGender] = useState(null);

  const getFormData = (object) => {
    const formData = new FormData();
    formData.append("image", image !== null ? image : "no-image.jpg");
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  };

  const handleUploadImage = (event) => {
    var file = event.target.files[0];
    if (file !== undefined) {
      var reader = new FileReader();
      reader.onloadend = function () {
        var b64 = reader.result;
        setImgUploadTemp(b64);
      };
      reader.readAsDataURL(file);
      setOpenCropImage(true);
    }
  };

  // const handleChangeGender = (e, setFieldValue, values) => {
  //   let test = values.sickness;
  //   if (test.includes(e.target.value)) {
  //     let testx = test.filter((item) => item !== e.target.value);
  //     setFieldValue("sickness", testx);
  //   } else {
  //     setFieldValue("sickness", test.concat(e.target.value));
  //   }
  // };

  const handleGetChangeGender = async (e, setFieldValue) => {
    setFieldValue("gender", e.target.value === null ? "" : e.target.value);
    // setSelectedGender(e.target.value);
  };

  const handleChangeCompany = (e, setFieldValue) => {
    setFieldValue("company", e.target.value);
    setFieldValue("transaction_type", "");
  };

  return (
    <Paper component={Box} p={2}>
      <Formik
        initialValues={{
          username: users.username,
          user_id: users.user_id,
          management_id: users.management_id,
          main_mgmt_id: users.main_mgmt_id,
          // password: "",
          lastname: "",
          firstname: "",
          middlename: "",
          gender: "",
          birthday: "",
          birthplace: "",
          street: "",
          barangay: "",
          city: "",
          occupation: "",
          civil_status: "",
          religion: "",
          mobile: "",
          telephone: "",
          email: "",
          philhealth: "",
          company: "",
          triage_staff: sidebarHeader.name,
          transaction_type: "reg-cashier",
          height: "",
          weight: "",
          pulse: "",
          temp: "",
          lmp: "",
          bp_systolic: "",
          bp_diastolic: "",
          blood_type: "",
          patient_condition: "",
        }}
        validationSchema={Yup.object().shape({
          // password: Yup.string().trim().required("Password is required."),
          lastname: Yup.string().trim().required("Lastname is required."),
          firstname: Yup.string().trim().required("Firstname is required."),
          gender: Yup.string().trim().required("Gender is required."),
          birthday: Yup.date().required("Birth date is required."),
          company: Yup.string().trim().required("Company is required."),
        })}
        onSubmit={async (
          values,
          { setErrors, setSubmitting, resetForm, setFieldValue }
        ) => {
          var errored = [];

          // if (image === null) {
          //   Notify.fieldRequired("image required");
          //   errored = "error";
          //   return;
          // }

          if (errored.length > 0) {
            console.log("form error.");
          } else {
            try {
              const request = await axios.post(
                "van/patients/newpatient-save",
                getFormData(values)
              );

              // if (request.data === "pass-invalid") {
              //   setErrors({ password: "Password is invalid." });
              //   Notify.fieldInvalid("password");
              // }
              if (request.data === "email-exist") {
                setErrors({ email: "Email is not available." });
                Notify.fieldInvalid("email");
              }

              if (request.data === "success") {
                Notify.successRequest("new patient");
                resetForm();
                setFieldValue("sickness", []);
                setImage(null);
                setSubmitting(true);
                getDoctorsPatient();
              }
            } catch (error) {
              const message = error.message || "Something went wrong";
              setErrors({ submit: message });
              setSubmitting(false);
            }
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          resetForm,
          isSubmitting,
          touched,
          values,
          setFieldValue,
        }) => (
          <form noValidate onSubmit={handleSubmit}>
            <Box mb={2}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Box flexGrow={1}>
                  <Typography
                    style={{ fontWeight: "bolder" }}
                    color="primary"
                    variant="h5"
                  >
                    New Patient
                  </Typography>
                </Box>

                <Box>
                  {isMobile ? (
                    <IconButton
                      color="primary"
                      onClick={() => profileimage.click()}
                    >
                      <CameraAlt />
                    </IconButton>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<CameraAlt />}
                      onClick={() => profileimage.click()}
                    >
                      Take Photo
                    </Button>
                  )}
                </Box>
                <input
                  type="file"
                  id="image"
                  onChange={handleUploadImage}
                  className="d-none"
                  ref={(ref) => (profileimage = ref)}
                />
              </Box>
            </Box>
            <Divider light />
            <Box my={1}>
              <Grid container spacing={1}>
                <Grid
                  component={Box}
                  hidden={image === null}
                  item
                  xs={12}
                  sm={4}
                >
                  <Box
                    width={"100%"}
                    height={
                      isMobile
                        ? 200
                        : window.innerWidth <= 959
                        ? 200
                        : window.innerWidth <= 898
                        ? 200
                        : 194
                    }
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    {image !== null && (
                      <Avatar
                        style={{
                          width: isMobile
                            ? 180
                            : window.innerWidth <= 959
                            ? 180
                            : window.innerWidth <= 898
                            ? 180
                            : 160,
                          height: isMobile
                            ? 180
                            : window.innerWidth <= 959
                            ? 180
                            : window.innerWidth <= 898
                            ? 180
                            : 160,
                        }}
                        alt="profile-pic"
                        src={image}
                      />
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12} sm={image === null ? 12 : 8}>
                  <Box my={1}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={4}>
                        <Box>
                          <TextField
                            error={Boolean(touched.lastname && errors.lastname)}
                            helperText={touched.lastname && errors.lastname}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.lastname}
                            fullWidth
                            required
                            name="lastname"
                            label="Lastname"
                            variant="outlined"
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Box>
                          <TextField
                            error={Boolean(
                              touched.firstname && errors.firstname
                            )}
                            helperText={touched.firstname && errors.firstname}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.firstname}
                            fullWidth
                            required
                            name="firstname"
                            label="Firstname"
                            variant="outlined"
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Box>
                          <TextField
                            error={Boolean(
                              touched.middlename && errors.middlename
                            )}
                            helperText={touched.middlename && errors.middlename}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.middlename}
                            fullWidth
                            name="middlename"
                            label="Middle Name"
                            variant="outlined"
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box my={1}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={4}>
                        <Box>
                          <TextField
                            error={Boolean(touched.gender && errors.gender)}
                            helperText={touched.gender && errors.gender}
                            onBlur={handleBlur}
                            // onChange={handleChange}
                            onChange={(e) =>
                              handleGetChangeGender(e, setFieldValue)
                            }
                            value={values.gender}
                            fullWidth
                            required
                            name="gender"
                            label="Gender"
                            variant="outlined"
                            select
                            SelectProps={{
                              native: true,
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          >
                            <option value={""}>Select</option>
                            <option value={"Male"}>Male</option>
                            <option value={"Female"}>Female</option>
                          </TextField>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Box>
                          <TextField
                            error={Boolean(touched.birthday && errors.birthday)}
                            helperText={touched.birthday && errors.birthday}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.birthday}
                            fullWidth
                            required
                            name="birthday"
                            label="Birthday"
                            variant="outlined"
                            type="date"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Box>
                          <TextField
                            error={Boolean(
                              touched.birthplace && errors.birthplace
                            )}
                            helperText={touched.birthplace && errors.birthplace}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.birthplace}
                            fullWidth
                            required
                            name="birthplace"
                            label="Birth Place"
                            variant="outlined"
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box my={1}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={4}>
                        <Box>
                          <TextField
                            error={Boolean(touched.street && errors.street)}
                            helperText={touched.street && errors.street}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.street}
                            fullWidth
                            required
                            name="street"
                            label="Street"
                            variant="outlined"
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Box>
                          <TextField
                            error={Boolean(touched.barangay && errors.barangay)}
                            helperText={touched.barangay && errors.barangay}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.barangay}
                            fullWidth
                            required
                            name="barangay"
                            label="Barangay"
                            variant="outlined"
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Box>
                          <TextField
                            error={Boolean(touched.city && errors.city)}
                            helperText={touched.city && errors.city}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.city}
                            fullWidth
                            required
                            name="city"
                            label="City"
                            variant="outlined"
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box my={1}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <Box>
                    <TextField
                      error={Boolean(touched.occupation && errors.occupation)}
                      helperText={touched.occupation && errors.occupation}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.occupation}
                      fullWidth
                      required
                      name="occupation"
                      label="Occupation"
                      variant="outlined"
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Box>
                    <TextField
                      error={Boolean(
                        touched.civil_status && errors.civil_status
                      )}
                      helperText={touched.civil_status && errors.civil_status}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.civil_status}
                      fullWidth
                      required
                      name="civil_status"
                      label="Civil Status"
                      variant="outlined"
                      select
                      SelectProps={{
                        native: true,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      <option value={""}>Select</option>
                      <option value={"Single"}>Single</option>
                      <option value={"Married"}>Married</option>
                      <option value={"Divorced"}>Divorced</option>
                    </TextField>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Box>
                    <TextField
                      error={Boolean(touched.religion && errors.religion)}
                      helperText={touched.religion && errors.religion}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.religion}
                      fullWidth
                      required
                      name="religion"
                      label="Religion"
                      variant="outlined"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box my={1}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <Box>
                    <TextField
                      error={Boolean(touched.mobile && errors.mobile)}
                      helperText={touched.mobile && errors.mobile}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.mobile}
                      fullWidth
                      required
                      name="mobile"
                      label="Mobile"
                      variant="outlined"
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Box>
                    <TextField
                      error={Boolean(touched.telephone && errors.telephone)}
                      helperText={touched.telephone && errors.telephone}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.telephone}
                      fullWidth
                      name="telephone"
                      label="Telephone"
                      variant="outlined"
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Box>
                    <TextField
                      error={Boolean(touched.email && errors.email)}
                      helperText={touched.email && errors.email}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.email}
                      fullWidth
                      required
                      name="email"
                      label="Email"
                      variant="outlined"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box my={1}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <Box>
                    <TextField
                      error={Boolean(touched.philhealth && errors.philhealth)}
                      helperText={touched.philhealth && errors.philhealth}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.philhealth}
                      fullWidth
                      name="philhealth"
                      label="Philhealth"
                      variant="outlined"
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Box>
                    <TextField
                      select
                      SelectProps={{ native: true }}
                      InputLabelProps={{ shrink: true }}
                      error={Boolean(touched.company && errors.company)}
                      helperText={touched.company && errors.company}
                      onBlur={handleBlur}
                      onChange={(e) => handleChangeCompany(e, setFieldValue)}
                      value={values.company}
                      fullWidth
                      required
                      name="company"
                      label="Company"
                      variant="outlined"
                    >
                      <option value=""> Select </option>
                      {accreditedCompany.length > 0 ? (
                        accreditedCompany.map((data, index) => (
                          <option key={index} value={data.value}>
                            {data.label}
                          </option>
                        ))
                      ) : (
                        <option value="" disabled>
                          No company found.
                        </option>
                      )}
                    </TextField>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Box>
                    <TextField
                      error={Boolean(
                        touched.patient_condition && errors.patient_condition
                      )}
                      helperText={
                        touched.patient_condition && errors.patient_condition
                      }
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.patient_condition}
                      fullWidth
                      name="patient_condition"
                      label="Patient Condition"
                      variant="outlined"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Box my={3}>
                <Box mb={2}>
                  <Typography variant="h6" color="textSecondary">
                    Health information
                  </Typography>
                </Box>
                <Divider light />
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <TextField
                        error={Boolean(touched.height && errors.height)}
                        helperText={touched.height && errors.height}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.height}
                        fullWidth
                        required
                        name="height"
                        label="Height(ft)"
                        variant="outlined"
                        type="number"
                        InputProps={{
                          inputProps: {
                            min: 1,
                            max: 10000,
                            step: 0.01,
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <TextField
                        error={Boolean(touched.weight && errors.weight)}
                        helperText={touched.weight && errors.weight}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.weight}
                        fullWidth
                        required
                        name="weight"
                        label="Weight(kg)"
                        variant="outlined"
                        type="number"
                        InputProps={{
                          inputProps: {
                            min: 1,
                            max: 10000,
                            step: 0.01,
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <TextField
                        error={Boolean(touched.pulse && errors.pulse)}
                        helperText={touched.pulse && errors.pulse}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.pulse}
                        fullWidth
                        required
                        name="pulse"
                        label="Pulse"
                        variant="outlined"
                        type="number"
                        InputProps={{
                          inputProps: {
                            min: 1,
                            max: 10000,
                            step: 0.01,
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={values.gender === "Female" ? 3 : 6}>
                    <Box>
                      <TextField
                        error={Boolean(touched.temp && errors.temp)}
                        helperText={touched.temp && errors.temp}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.temp}
                        fullWidth
                        required
                        name="temp"
                        label="Temperature"
                        variant="outlined"
                        type="number"
                        InputProps={{
                          inputProps: {
                            min: 1,
                            max: 10000,
                            step: 0.01,
                          },
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid
                    hidden={values.gender === "Female" ? false : true}
                    item
                    xs={12}
                    sm={3}
                  >
                    <Box>
                      <TextField
                        error={Boolean(touched.lmp && errors.lmp)}
                        helperText={touched.lmp && errors.lmp}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.lmp}
                        fullWidth
                        required
                        name="lmp"
                        label="LMP"
                        variant="outlined"
                        type="date"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <TextField
                        error={Boolean(
                          touched.bp_systolic && errors.bp_systolic
                        )}
                        helperText={touched.bp_systolic && errors.bp_systolic}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.bp_systolic}
                        fullWidth
                        required
                        name="bp_systolic"
                        label="BP Systolic"
                        variant="outlined"
                        type="number"
                        InputProps={{
                          inputProps: {
                            min: 1,
                            max: 10000,
                            step: 0.01,
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <TextField
                        error={Boolean(
                          touched.bp_diastolic && errors.bp_diastolic
                        )}
                        helperText={touched.bp_diastolic && errors.bp_diastolic}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.bp_diastolic}
                        fullWidth
                        required
                        name="bp_diastolic"
                        label="BP Diastolic"
                        variant="outlined"
                        type="number"
                        InputProps={{
                          inputProps: {
                            min: 1,
                            max: 10000,
                            step: 0.01,
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>

                <Box mt={2}>
                  <TextField
                    error={Boolean(touched.blood_type && errors.blood_type)}
                    helperText={touched.blood_type && errors.blood_type}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.blood_type}
                    fullWidth
                    required
                    name="blood_type"
                    label="Blood Type"
                    variant="outlined"
                    select
                    SelectProps={{ native: true }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
                    <option value=""> Select </option>
                    <option value="A"> A </option>
                    <option value="B"> B </option>
                    <option value="AB"> AB </option>
                    <option value="O"> O </option>
                    <option value="A-positive"> A-Positive </option>
                    <option value="A-negative"> A-Negative </option>
                    <option value="B-positive"> B-Positive </option>
                    <option value="B-negative"> B-Negative </option>
                    <option value="O-positive"> O-Positive </option>
                    <option value="O-negative"> O-Negative </option>
                    <option value="AB-positive">AB-Positive </option>
                    <option value="AB-negative">AB-Negative </option>
                  </TextField>
                </Box>
              </Box>
            </Box>

            {errors.submit && (
              <Box mt={3}>
                <FormHelperText error>{errors.submit}</FormHelperText>
              </Box>
            )}

            <Box mb={2} display="flex">
              <Box flexGrow={1} />

              <Button
                variant="contained"
                color="default"
                onClick={resetForm}
                startIcon={<ClearIcon />}
              >
                Clear
              </Button>
              <Box ml={2}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={
                    isSubmitting ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <CheckIcon />
                    )
                  }
                  disabled={isSubmitting}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </form>
        )}
      </Formik>
      <Dialog
        open={openCropImage}
        fullScreen
        onClose={() => setOpenCropImage(false)}
        TransitionComponent={Zoom}
        transitionDuration={900}
      >
        <Box
          display="flex"
          width="100%"
          height="80vh"
          justifyContent="center"
          alignItems="center"
        >
          <Cropper
            style={{ height: "100%", width: "100%" }}
            zoomTo={0.5}
            aspectRatio={1}
            src={imgUploadTemp}
            viewMode={1}
            guides={false}
            background={false}
            responsive={true}
            dragMode={"move"}
            cropBoxResizable={true}
            checkOrientation={false}
            rotatable
            scalable
            ref={cropperRef}
          />
        </Box>
        <Box
          display="flex"
          width="100%"
          height="20vh"
          justifyContent="center"
          alignItems="center"
          border={1}
        >
          <Button
            color="primary"
            variant="contained"
            startIcon={<Send />}
            onClick={() => {
              const imageElement = cropperRef.current;
              const cropper = imageElement.cropper;
              setImage(cropper.getCroppedCanvas().toDataURL());
              setImgUploadTemp(null);
              setOpenCropImage(false);
            }}
          >
            Confirm
          </Button>
        </Box>
      </Dialog>
    </Paper>
  );
};

export default VanNewPatient;
